import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_361: DocMigration = {
  maxSchemaVersion: "0.0.361",
  description: "Rename DoorDescriptor and DoorPlacement reported name props",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];
      if (setting.type === "DOOR_CATALOG_SETTINGS") {
        for (const doorId in setting.doorTypes) {
          const door = setting.doorTypes[doorId];
          door.reportedName = door.shortName;
          delete door.shortName;
        }
      }
    }

    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      if (opening.type === "DOOR" || opening.type === "DOOR_V2") {
        if (opening.tagOverride !== undefined) {
          opening.reportedName = opening.tagOverride;
          delete opening.tagOverride;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_361;
